{
  "dismiss": "התעלם"
}